import React from 'react';
import styled from 'styled-components';

export default (props) => (
  <SVG {...props} width="22px" height="22px" viewBox="0 0 22 22" version="1.1">
    <g
      id="Knowledge-Hub"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      opacity="0.800000012"
    >
      <g
        id="FC-design-system-atoms-icons"
        transform="translate(-202.000000, -3213.000000)"
        fill="#FFFFFF"
        fillRule="nonzero"
      >
        <g id="Group-3" transform="translate(0.000000, 3144.000000)">
          <g id="Group-6" transform="translate(61.000000, 55.000000)">
            <g id="SM-icons" transform="translate(39.000000, 13.000000)">
              <path
                d="M117.338759,22.4250149 C119.021586,22.3453184 120.512198,21.9609352 121.74033,20.7281348 C122.968415,19.5000036 123.352798,18.0093913 123.437164,16.3265645 C123.535629,14.5921936 123.535629,9.39846516 123.437164,7.6640943 C123.357513,5.9812675 122.97313,4.49065521 121.74033,3.26252398 C120.512198,2.03443853 119.021586,1.65005529 117.338759,1.56568965 C115.604388,1.46722491 110.405945,1.46722491 108.671574,1.56568965 C106.993462,1.64534033 105.50285,2.02972357 104.27005,3.2578548 C103.037249,4.48598603 102.657535,5.97659832 102.57317,7.65942512 C102.474751,9.39379598 102.474751,14.5921936 102.57317,16.3265645 C102.652866,18.0093913 103.037249,19.5000036 104.27005,20.7281348 C105.50285,21.956266 106.988793,22.3406035 108.671574,22.4250149 C110.405945,22.5234339 115.604388,22.5234339 117.338759,22.4250149 Z M113.007501,20.6062326 C111.479398,20.6062326 108.193487,20.7281348 106.815347,20.1843586 C105.896617,19.8187437 105.188779,19.1109512 104.818495,18.1875067 C104.27005,16.8046975 104.396621,13.5234553 104.396621,11.9953523 C104.396621,10.4672035 104.274719,7.1812921 104.818495,5.80315208 C105.18411,4.88442258 105.891902,4.1765843 106.815347,3.80630015 C108.198156,3.2578548 111.479398,3.38442615 113.007501,3.38442615 C114.53565,3.38442615 117.821562,3.26252398 119.199702,3.80630015 C120.118431,4.17191512 120.826269,4.87970762 121.196553,5.80315208 C121.744999,7.18596128 121.618427,10.4672035 121.618427,11.9953523 C121.618427,13.5234553 121.744999,16.8093667 121.196553,18.1875067 C120.830939,19.1062362 120.123146,19.8140745 119.199702,20.1843586 C117.816892,20.732804 114.53565,20.6062326 113.007501,20.6062326 Z M118.613765,7.64532603 C119.307505,7.64532603 119.870003,7.08754233 119.870003,6.38908818 C119.870003,5.69534899 119.307505,5.13285033 118.613765,5.13285033 C117.920026,5.13285033 117.357528,5.69534899 117.357528,6.38908818 C117.357528,7.08282737 117.915311,7.64532603 118.613765,7.64532603 Z M113.007501,17.3812495 C115.988772,17.3812495 118.393444,14.9765769 118.393444,11.9953523 C118.393444,9.01408192 115.988772,6.60940931 113.007501,6.60940931 C110.026277,6.60940931 107.621604,9.01408192 107.621604,11.9953523 C107.621604,14.9765769 110.026277,17.3812495 113.007501,17.3812495 Z M113.007501,15.4968698 C111.080962,15.4968698 109.505984,13.9265611 109.505984,11.9953523 C109.505984,10.0640977 111.076293,8.49378897 113.007501,8.49378897 C114.938756,8.49378897 116.509065,10.0640977 116.509065,11.9953523 C116.509065,13.9265611 114.934087,15.4968698 113.007501,15.4968698 Z"
                id="IG"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </SVG>
);

const SVG = styled.svg`
  #FC-design-system-atoms-icons {
    fill: #ffffffcc;
  }

  &:hover {
    #FC-design-system-atoms-icons {
      fill: #fff;
    }
  }
`;
